import React from 'react';
import dateFormat from 'dateformat';
import * as Date from '../dates/dateHelpers';
import { markupHelpers } from '../../helpers';
import * as Buttons from '../ui/buttons';
import { getAbbrMonthYear } from './../../../../../../helpers/common/date-util';

export const ExperienceItem = props => {
	const {
		title,
		company,
		location,
		description,
		expertise_experience,
		market_experience,
		sector_experience,
		industry_experience,
		start_date,
		end_date,
		buttonHandlers,
		guestMode,
	} = props;

	const convertedTitle = markupHelpers.escapeHtmlHelper(title),
		convertedCompany = markupHelpers.escapeHtmlHelper(company),
		convertedLocation = markupHelpers.escapeHtmlHelper(location),
		convertedDescription = markupHelpers.escapeHtmlHelper(description);

	let start =  start_date ? getAbbrMonthYear( start_date ) : '';
	let end = end_date ? Date.formatEndDate( end_date ) : '';

	return (
		<div className="item-experience">
			{/*show when not in guestMode*/}
			{!guestMode && (
				<div className="item-display-mode">
					<Buttons.EditButton {...buttonHandlers} />
				</div>
			)}
			{/*/////////*/}
			<div className="row">
				<div className=" col-12 col-sm-4 col-lg-3 new-profile-label">Title</div>
				<div className=" col-12 col-sm-8 col-lg-9 new-profile-info item-header">
					<span
						className="width-reducer"
						dangerouslySetInnerHTML={{ __html: convertedTitle }}
					/>
				</div>
			</div>
			<div className="row">
				<div className=" col-12 col-sm-4 col-lg-3 new-profile-label">
					Company
				</div>
				<div className=" col-12 col-sm-8 col-lg-9 new-profile-info">
					<span
						className="width-reducer"
						dangerouslySetInnerHTML={{ __html: convertedCompany }}
					/>
				</div>
			</div>
			{!location || location === 'null' ? null : (
				<div className="row">
					<div className=" col-12 col-sm-4 col-lg-3 new-profile-label">
						Location
					</div>
					<div
						className=" col-12 col-sm-8 col-lg-9 new-profile-info"
						dangerouslySetInnerHTML={{ __html: convertedLocation }}
					/>
				</div>
			)}
			<div className="row">
				<div className=" col-12 col-sm-4 col-lg-3 new-profile-label">Dates</div>
				<div className=" col-12 col-sm-8 col-lg-9 new-profile-info">
					{ start } - { end }
				</div>
			</div>
			{!description || description === 'null' ? null : (
				<div className="row">
					<div className=" col-12 col-sm-4 col-lg-3 new-profile-label">
						Description
					</div>
					<div
						className=" col-12 col-sm-8 col-lg-9 new-profile-info editor"
						dangerouslySetInnerHTML={{ __html: convertedDescription }}
					/>
				</div>
			)}
			{!expertise_experience || !expertise_experience.length ? null : (
				<div className="row">
					<div className=" col-12 col-sm-4 col-lg-3 new-profile-label">
						Expertise
					</div>
					<div className=" col-12 col-sm-8 col-lg-9 new-profile-info">
						<ul className="new-profile-listed-details">
							{expertise_experience.map((expertise, i) => (
								<li key={i}>{expertise.name}</li>
							))}
						</ul>
					</div>
				</div>
			)}

			{!industry_experience || !industry_experience.length ? null : (
				<div className="row">
					<div className=" col-12 col-sm-4 col-lg-3 new-profile-label">
						Industry
					</div>
					<div className=" col-12 col-sm-8 col-lg-9 new-profile-info">
						<ul className="new-profile-listed-details">
							{industry_experience.map((industry, i) => (
								<li key={i}>{industry.name}</li>
							))}
						</ul>
					</div>
				</div>
			)}

			{!market_experience || !market_experience.length ? null : (
				<div className="row">
					<div className=" col-12 col-sm-4 col-lg-3 new-profile-label">
						Market
					</div>
					<div className=" col-12 col-sm-8 col-lg-9 new-profile-info">
						<ul className="new-profile-listed-details">
							{market_experience.map((market, i) => (
								<li key={i}>{market.name}</li>
							))}
						</ul>
					</div>
				</div>
			)}

			{!sector_experience || !sector_experience.length ? null : (
				<div className="row">
					<div className=" col-12 col-sm-4 col-lg-3 new-profile-label">
						Sector
					</div>
					<div className=" col-12 col-sm-8 col-lg-9 new-profile-info">
						<ul className="new-profile-listed-details">
							{sector_experience.map((sector, i) => (
								<li key={i}>{sector.name}</li>
							))}
						</ul>
					</div>
				</div>
			)}
		</div>
	);
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/ExperienceItem.js